{
  "title": "Circle of Power",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level abjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self (30-foot radius)",
  "components": "V",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Divine energy radiates from you, distorting and diffusing magical energy within 30 feet of you. Until the spell ends, the sphere moves with you, centered on you. For the duration, each friendly creature in the area (including you) has advantage on saving throws against spells and other magical effects.",
    "Additionally, when an affected creature succeeds on a saving throw made against a spell or magical effect that allows it to make a saving throw to take only half damage, it instead takes no damage if it succeeds on the saving throws."
  ],
  "spellLists": ["paladin"]
}
